//@ts-nocheck
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { configureStore } from "./redux/index";
import "react-toastify/dist/ReactToastify.css";
// bootstrap.css kaldırıldı — pazarlama sitesi v2 tasarımıyla çakışıyordu (kendi tokenları var).
// D-214: ReactGA statik import DEĞİL. Statik olsaydı hem react-ga4 ana bundle'a
// girer hem de initialize() ilk render'dan önce çalışıp GTM'in 189 KB'lık
// script'ini kritik yola sokardı (ölçüm: 176 KB'ı hiç çalışmıyor).
// Artık `load` + idle'da dinamik import ediliyor; sayfa görüntüleme olayı
// kuyruğa alınıp init sonrası gönderiliyor, ölçüm kaybı yok.



const { store, persistor } = configureStore({});
// React 18 createRoot (eski ReactDOM.render kaldırıldı — "no longer supported"
// konsol hatasını ve legacy modu giderir).
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
/* --- Analitik: ilk boyadan SONRA --------------------------------------- */
const startAnalytics = () => {
  // Prerender de gerçek bir tarayıcıda koşuyor: guard olmasa 592 sayfa için
  // 592 sahte pageview GA'ya giderdi. react-snap kendi user-agent'ını
  // "ReactSnap" olarak damgalıyor; localhost kontrolü ikinci emniyet.
  const ua = navigator.userAgent || "";
  if (ua.includes("ReactSnap") || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") return;
  import("react-ga4")
    .then(({ default: ReactGA }) => {
      ReactGA.initialize("G-ZNFV7BTTEV");
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    })
    .catch(() => { /* analitik yüklenemedi: sayfa etkilenmez */ });
};

// `load` olayı zaten geçtiyse hemen, geçmediyse load'dan sonra — her iki
// durumda da tarayıcı boştayken. Etkileşim beklenmiyor: kısa oturumlar kaçmasın.
const whenIdle = (fn: () => void) =>
  ("requestIdleCallback" in window
    ? (window as any).requestIdleCallback(fn, { timeout: 3000 })
    : setTimeout(fn, 1200));

if (document.readyState === "complete") whenIdle(startAnalytics);
else window.addEventListener("load", () => whenIdle(startAnalytics), { once: true });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
